import { onDateChangeProps } from '@anm/components/stream/types';
import { useCallback, useState } from 'react';

import { getDateIn2Hours } from './helpers';

const useStreamDate = (schedule?: string | null) => {
  const [date, setSelectedDate] = useState(schedule ? new Date(schedule).getTime() : getDateIn2Hours());

  const handleDateChange = useCallback(
    ({ dates, isDatePicker }: onDateChangeProps) => {
      const newDate = new Date(dates[0]);
      const oldDate = new Date(date);

      newDate.setHours(oldDate.getHours());
      const pickerValue = newDate.setMinutes(oldDate.getMinutes());

      const newValue = isDatePicker ? pickerValue : dates[0];
      setSelectedDate(newValue);
    },
    [date]
  );

  return [date, handleDateChange, setSelectedDate] as const;
};

export default useStreamDate;
